import { Component, OnInit } from '@angular/core';
import { Enums } from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sortDisplayName } from '../../../../helpers/display-names';
import { SearchStateService } from '../../../research/services/search-state.service';
import { CyborgSelectOption } from '../cyborg-select/cyborg-select.component';

@Component({ standalone: false, 
  selector: 'cyborg-search-sort',
  templateUrl: './search-sort.component.html',
  styleUrls: ['./search-sort.component.scss'],
})
export class SearchSortComponent implements OnInit {
  public options: CyborgSelectOption[];
  public sort$: Observable<string>;

  constructor(public searchStateService: SearchStateService) {}

  public ngOnInit(): void {
    this.sort$ = this.searchStateService.state.pipe(
      map((state) => sortDisplayName(state.sort))
    );

    this.options = Object.keys(Enums.CyborgSortEnum).map((key) => {
      return {
        id: Enums.CyborgSortEnum[key],
        assignName: sortDisplayName(Enums.CyborgSortEnum[key]),
      };
    });
  }

  public onSelect(id: string): void {
    this.searchStateService.setSort(<Enums.CyborgSortEnum>id);
  }
}
